import { type CSSProperties } from "react";

// Faixas "fora do expediente" posicionadas em % sobre um track relativo (mini-gantt
// do modal e swimlanes da timeline). Cor (sombra) + padrão (hachura diagonal, .off-hours-hatch) —
// nunca só cor. z-0/pointer-events-none: ficam ATRÁS dos blocos de OP e não interceptam cliques.
export function ExpedienteBands({ bands }: { bands: { leftPct: number; widthPct: number }[] }) {
  return (
    <>
      {bands.map((b, i) => (
        <div
          key={i}
          aria-hidden
          title="Fora do expediente"
          style={{ "--l": `${b.leftPct}%`, "--w": `${b.widthPct}%` } as CSSProperties}
          className="off-hours-hatch bg-bg-muted-rd/30 pointer-events-none absolute bottom-0 left-[var(--l)] top-0 z-0 w-[var(--w)]"
        />
      ))}
    </>
  );
}
